import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import MobileApp from "../../components/mobile-app";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";
import Counter from "../../components/counter";

import { cartData } from "../../data/data";
import ScrollToTop from "../../components/scroll-to-top";
import { useSelector } from "react-redux";
import {
  useDeleteItemMutation,
  useGetCartItemsQuery,
  useUpdateItemMutation,
} from "../../redux/services/cart";
import { toast } from "react-toastify";

export default function Shopcart(props) {
  const user = useSelector((state) => state.auth.user);

  const { data, isLoading } = useGetCartItemsQuery({
    filter: { user_id: user?.id },
  });
  const [deleteItem, { data: deletedItem }] = useDeleteItemMutation();
  const [updateItem, { data: updatedItems, isLoading: updating }] =
    useUpdateItemMutation();

  const hanldeChange = (count, id) => {
    console.log(count, id);
    updateItem({
      id: id,
      quantity: count,
    });
  };

  const totalPrice = data?.reduce((total, item) => {
    const price = item.product.sale_price ?? item.product.price;
    return total + price * item.quantity;
  }, 0);

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative table w-full py-20 lg:py-24 md:pt-28 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 mt-14">
            <h3 className="text-3xl leading-normal font-semibold">Fashion</h3>
          </div>

          <div className="relative mt-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                <Link to="/">TAS e store</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li
                className="inline-block uppercase text-[13px] font-bold text-orange-500"
                aria-current="page"
              >
                SHOPCART
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-1">
            <div className="relative overflow-x-auto shadow dark:shadow-gray-800 rounded-md">
              <table className="w-full text-start">
                <thead className="text-sm uppercase bg-slate-50 dark:bg-slate-800">
                  <tr>
                    <th scope="col" className="p-4 w-4"></th>
                    <th scope="col" className="text-start p-4 min-w-[220px]">
                      Product
                    </th>
                    <th scope="col" className="p-4 w-24 min-w-[100px]">
                      Price
                    </th>
                    <th scope="col" className="p-4 w-56 min-w-[220px]">
                      Qty
                    </th>
                    <th scope="col" className="p-4 w-24 min-w-[100px]">
                      Total($)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => {
                    return (
                      <tr
                        className="bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-800"
                        key={index}
                      >
                        <td className="p-4">
                          <div
                            role="button"
                            onClick={async () => {
                              await deleteItem(item.id);
                              toast.success("Product removed from cart");
                            }}
                          >
                            <i className="mdi mdi-window-close text-red-600"></i>
                          </div>
                        </td>
                        <td className="p-4">
                          <span className="flex items-center">
                            <img
                              src={item.product.image_urls[0]}
                              className="rounded shadow dark:shadow-gray-800 w-12"
                              alt=""
                            />
                            <span className="ms-3">
                              <span className="block font-semibold">
                                {item.product.title}
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="p-4 text-center">
                          $ {item.product.sale_price ?? item.product.price}
                        </td>
                        <td className="p-4 text-center">
                          <Counter
                            onChange={(count) => hanldeChange(count, item.id)}
                            qtn={item.quantity}
                            total=""
                          />
                        </td>
                        <td className="p-4  text-end">
                          ${" "}
                          {(item.product.sale_price ?? item.product.price) *
                            item.quantity}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
              <div className="lg:col-span-9 md:order-1 order-3">
                <div className="space-x-1">
                    <Link
                      to={data && data.length > 0 ? "/shop-checkout" : "#"}
                      className={`py-2 px-5 inline-block font-semibold tracking-wide align-middle text-base text-center rounded-md mt-2 ${
                        data && data.length > 0
                          ? "bg-orange-500 text-white"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`} 
                    >
                      Check out
                    </Link>
                </div>
              </div>

              <div className="lg:col-span-3 md:order-2 order-1">
                <ul className="list-none shadow dark:shadow-gray-800 rounded-md">
                  <li className="flex justify-between p-4">
                    <span className="font-semibold text-lg">Subtotal :</span>
                    <span className="text-slate-400">$ {totalPrice}</span>
                  </li>
                  {/* <li className="flex justify-between p-4 border-t border-gray-100 dark:border-gray-800">
                    <span className="font-semibold text-lg">Taxes :</span>
                    <span className="text-slate-400">$ 150</span>
                  </li> */}
                  <li className="flex justify-between font-semibold p-4 border-t border-gray-200 dark:border-gray-600">
                    <span className="font-semibold text-lg">Total :</span>
                    <span className="font-semibold">$ {totalPrice}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* <MobileApp /> */}
      </section>
      <Footer />
      {/* <Switcher/> */}
      <ScrollToTop />
    </>
  );
}
